import React, {useState} from 'react';
import {RolesToolbar} from './RolesToolbar';
import RolesTable from './RolesTable';
import {useControllers} from '../../../../../common/helpers/react/hooks/useControllers';
import LoadingProgress from '../../../common/placeholders/loading/LoadingProgress';
import RolesAddRolesSearch from "./RolesAddRolesSearch";

export const AddAggregatedRoleModal = () => {
    const [checkedRows, setCheckedRows] = useState<string[]>([]);
    const [enabledById, setEnabledById] = useState<Record<string, boolean>>({});
    const dialog = useControllers().dialog;
    const roles = useControllers().roles;
    const isBusy = ['GETTING_PARENT_ROLES', 'UPDATING_PARENT_ROLES'].includes(roles.isBusy$().useState() as string);
    const modal = dialog.getCurrentModal$().useState() ?? {};
    modal.data = {
        add: checkedRows,
        parentRoles: checkedRows.map(id => ({
            id: Number(id),
            enabled: enabledById[id] ?? true
        }))
    };

    return (<>
        {isBusy && <LoadingProgress/>}
        <RolesAddRolesSearch addAggregatedRolesMode={true}/>
        <RolesToolbar addAggregatedRolesMode={true}/>
        <RolesTable addAggregatedRolesMode={true} checkedRows={checkedRows}
                    setCheckedRows={setCheckedRows} mainTableView={false}
                    addEnabledById={enabledById}
                    onAddEnabledChange={(id, enabled) => setEnabledById(current => ({
                        ...current,
                        [id]: enabled
                    }))}/>
    </>);
};